<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Rescue Center</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)" color="primary">
    <ion-refresher-content pullingText="Pull to refresh" refreshingSpinner="circular" refreshingText="Refreshing...">
    </ion-refresher-content>
  </ion-refresher>
  <div class="ion-padding ion-text-center" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <ion-segment value="All" [(ngModel)]="filter" (ionChange)="filterCases()">
      <ion-segment-button value="All">
        <ion-label>All</ion-label>
      </ion-segment-button>
      <ion-segment-button value="0">
        <ion-label>OnGoing</ion-label>
      </ion-segment-button>
      <ion-segment-button value="1">
        <ion-label>Solved</ion-label>
      </ion-segment-button>
    </ion-segment>
    <ion-grid>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-button color="danger" expand="full" [routerLink]="['/authorities']"><ion-icon name="warning-outline"
              slot="start"></ion-icon>Urgent case? Contact authorities</ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="ion-padding ion-text-center" *ngIf="cases.length ===0">
      <ion-text color="darkmimbo">There are no posts yet. You can start by adding your own.</ion-text>
    </div>

    <div *ngIf="cases.length >0">
      <app-case-card *ngFor="let casee of cases| casesFilter:filter" [cases]="cases" [casee]="casee"></app-case-card>
    </div>
  </div>

  <ion-fab-button routerLink="add-case"><ion-icon name="add-outline" class="add-outline"></ion-icon></ion-fab-button>
  <ion-infinite-scroll (ionInfinite)="onIonInfinite($event)" *ngIf="!isLoading && HasMoreData">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <div style="width: 100%; height: 70px"></div>
</ion-content>